import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";
import CheckValue from "../../../../Utils/CheckValue/CheckValue";

export default function Low(props) {
  const socket = useContext(SocketContext);
  const { symbol_id } = props;

  const [low, setLow] = useState(0);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.Low !== undefined) {
        setLow(data.Low);
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return (
    <div className="menuLow">
      <CheckValue number={low} />
    </div>
  );
}
